module.exports = __webpack_public_path__ + "img/4.df8defde.jpg";